<script setup lang="ts">
/**
 * UI-kit component
 * Category: Links
 * Name: OrderRelationLink
 */
import type { OrderRelationLinkProps } from '../types/interfaces'

import { faCommentDots } from '@fortawesome/pro-regular-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'OrderRelationLink',
})

withDefaults(defineProps<OrderRelationLinkProps>(), {
  notes: null,
})
</script>

<template>
  <span class="order-relation-link">
    <LinkTextPrimary :href="href">
      {{ text }}
    </LinkTextPrimary>
    <AppTooltip
      v-if="notes"
      :text="notes"
      size="small"
      placement="top"
    >
      <AppIcon
        :icon="faCommentDots"
        size="small"
        color="slate-400"
      />
    </AppTooltip>
  </span>
</template>

<style lang="scss" scoped src="../styles/_order-relation-link.scss" />
